import { theme } from 'theme';
import { ChakraProvider } from "@chakra-ui/react"
import Error from 'next/error'
import Error403 from './403'
import Error404 from './404'

const ErrorPage = ({ statusCode }) => {
  const renderStatusCode = () => {
    switch(statusCode) {
      case 403:
        return <Error403 />
      case 404:
        return <Error404 />
      default:
        return <Error statusCode={statusCode} />
    }
  }

  return (
    <ChakraProvider theme={theme}>
      {renderStatusCode()}
    </ChakraProvider>
  )
}

export default ErrorPage
